import { put, takeLeading } from 'redux-saga/effects';

import managerReviewsApi from 'api/managerReviews';
import { apiErrorHandler } from 'utils';

import {
  GET_MANAGER_REVIEWS,
  GET_MANAGER_REVIEWS_FAILED,
  GET_MANAGER_REVIEWS_SUCCESS,
} from './actionTypes';

function* getManagerReviews({ payload }) {
  try {
    const response = yield managerReviewsApi.getManagerReviews(payload);

    yield put({
      type: GET_MANAGER_REVIEWS_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_MANAGER_REVIEWS_FAILED,
    });
  }
}

export default function* managerReviewSaga() {
  yield takeLeading(GET_MANAGER_REVIEWS, getManagerReviews);
}
